import React from 'react';
import {t} from '@lingui/core/macro';

import FiltersModal from 'shared/ui/Modal/FiltersModal/FiltersModal';
import {FILTERS_KEPT_NONE} from 'shared/lib/filterHelper';

import HttpIncidentFiltersForm from './HttpIncidentFiltersForm';

interface IHttpIncidentFiltersModalProps {
    open: boolean,
    handleClose: () => void;
}

const HttpIncidentFiltersModal: React.FC<IHttpIncidentFiltersModalProps> = ({open, handleClose}) => (
    <FiltersModal header={t`Фильтры`} open={open} handleClose={handleClose} keepParams={FILTERS_KEPT_NONE}>
        <HttpIncidentFiltersForm onClose={handleClose}/>
    </FiltersModal>
);

export default HttpIncidentFiltersModal;
